import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFullUpFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20ZM19 16.4142V26.2308V27.2308H21V26.2308V16.4142L25.2929 20.7071L26.7071 19.2929L21 13.5858V13.4615H20.8757L20.7071 13.2929L20 12.5858L19.2929 13.2929L19.1243 13.4615H19V13.5858L13.2929 19.2929L14.7071 20.7071L19 16.4142Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowFullUpFilled);
export default ForwardRef;
